import { atom } from 'jotai';

const readyToRequestMicPermissionsInternalAtom = atom<boolean>(false);
export const readyToRequestMicPermissionsAtom = atom(
  (get) => {
    return get(readyToRequestMicPermissionsInternalAtom);
  },
  (_get, set, isReady: boolean) => {
    set(readyToRequestMicPermissionsInternalAtom, isReady);
  }
);
